<template>
  <div class="container">
    <div class="topic_title">题目设置</div>
    <el-form ref="form" :model="form" label-width="80px" class="formlist">
      <el-form-item label="题目">
        <el-input v-model="form.question"></el-input>
      </el-form-item>
      <el-form-item label="配图" class="image_box">
        <el-upload
          :class="
            ['app', 'agent'].indexOf(type) >= 0
              ? 'avatar-uploader'
              : 'avatar-uploader'
          "
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img
            v-if="form.img_url"
            :src="form.img_url"
            :class="['app', 'agent'].indexOf(type) >= 0 ? 'avatar' : 'product'"
          />
          <i
            v-else
            :class="
              ['app', 'agent'].indexOf(type) >= 0
                ? 'el-icon-plus avatar-uploader-icon'
                : 'el-icon-plus product-uploader-icon'
            "
          ></i>
         
        </el-upload>
        <i class="el-icon-delete imagedele" v-if="form.img_url" @click="deleteimageHandel"></i>
      </el-form-item>
      <div class="option">选项</div>
      <div v-if="types == 2 || result_type == 2">
        <el-form-item
          :label="String.fromCharCode(65 + index)"
          v-for="(option, index) in form.options"
          :key="index"
        >
          <label class="optionlist">
            <el-input
              type="text"
              v-model="option.answer"
              :placeholder="'输入测试选项内容 '"
              style="width: 500px"
            ></el-input>
            &nbsp; &nbsp;
            <el-input
              type="number"
              v-model="option.score"
              placeholder="分数"
            ></el-input>
            &nbsp; &nbsp;
            <i
              class="el-icon-delete"
              @click="removeOption(index)"
              style="color: red; margin-left: 10px"
            ></i>
          </label>
        </el-form-item>
        <el-form-item>
          <el-button @click="addOption">添加选项</el-button>
          <el-button @click="copyOption">复制选项</el-button>
        </el-form-item>
      </div>
      <div v-if="types == 1 || result_type == 1">
        <el-form-item
          :label="String.fromCharCode(65 + index)"
          v-for="(option, index) in form.options"
          :key="index"
        >
          <label class="optionlist">
            <el-input
              type="text"
              v-model="option.answer"
              :placeholder="'输入测试选项内容 '"
              style="width: 500px"
            ></el-input>
            &nbsp; &nbsp;
            <i
              class="el-icon-delete"
              @click="removeOption(index)"
              style="color: red; margin-left: 10px"
            ></i>
          </label>
        </el-form-item>
        <el-form-item>
          <el-button @click="addOption">添加选项</el-button>
          <el-button @click="copyOption">复制选项</el-button>
        </el-form-item>
      </div>
      <div v-if="types == 3 || result_type == 3">
        <el-form-item
          :label="String.fromCharCode(65 + index)"
          v-for="(option, index) in form.options"
          :key="index"
        >
          <label class="optionlist">
            <el-input
              type="text"
              v-model="option.answer"
              :placeholder="'输入测试选项内容 '"
              style="width: 500px"
            ></el-input>
            &nbsp; &nbsp;
            <el-select v-model="option.score" placeholder="请选择">
              <el-option
                v-for="item in selectList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            &nbsp; &nbsp;
            <i
              class="el-icon-delete"
              @click="removeOption(index)"
              style="color: red; margin-left: 10px"
            ></i>
          </label>
        </el-form-item>
        <el-form-item>
          <el-button @click="addOption">添加选项</el-button>
          <el-button @click="copyOption">复制选项</el-button>
  
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";
import { getTestDimensionList } from "@/api/coupon"
export default {
  data() {
    return {
      form: {
        question: "",
        img_url: "",
        options: [
          { answer: "", score: "", value: String.fromCharCode(65),}, // 分数
          { answer: "", score: "", value: String.fromCharCode(66) ,}
        ],
      },
      type: "app",
      ossAction: "",

      options2: [
        { value: String.fromCharCode(65), answer: "" ,},
        { value: String.fromCharCode(66), answer: "" ,},
      ], // 随机
      options3: [
        { answer: "", score: "", value: String.fromCharCode(65),},
        { answer: "", score: "", value: String.fromCharCode(66),},
      ], //维度
      selectList: [
        {
          id: "选项1",
          title: "黄金糕",
        },
      ],
    };
  },
  props: ["types", "id", "list","result_type","seleceList","getData","resultsList"],
  created() {
    if (this.types == 1) {
      this.form.options = this.options2;
    } else if (this.types == 3) {
      this.form.options = this.options3;
    }
  },
  mounted() {

    setTimeout(()=>{
      if(this.list){
      if (Object.keys(this.list).length !== 0) {
      this.form = Object.assign({}, this.list);
    }
    }
    },1000)
    this.getTestDimensionListHandel()
    // console.log(this.list, this.seleceList,'props: ["types", "id"],');
  },
  methods: {
    copyOption(){
      console.log(111,this.list,'所有选项',this.form);
      this.getData();
  setTimeout(()=>{
    if (this.resultsList) {
      console.log(this.resultsList[0].options, '<el-button @click="copyOption">复制选项</el-button>',this.form.options );
       this.form.options = this.resultsList[0].options
    }
  },0)
    },
    deleteimageHandel(){ // 删除图片
      this.form.img_url = ''
    },
    addOption() {
      // 添加
      if (this.types == 1) {
        const newIndex = this.form.options.length; // 获取当前索引
        const option = {
          answer: "",
          value: String.fromCharCode(65 + newIndex),
   
        };
        this.form.options.push(option); // 将选项添加到数组中
      } else if (this.types == 2) {
        const newIndex = this.form.options.length; // 获取当前索引
        const option = {
          answer: "",
          score: "",
          value: String.fromCharCode(65 + newIndex),

        };
        this.form.options.push(option); // 将选项添加到数组中
      } else {
        const newIndex = this.form.options.length; // 获取当前索引
        const option = {
          answer: "",
          score: "",
          value: String.fromCharCode(65 + newIndex),
    
        };
        this.form.options.push(option); // 将选项添加到数组中
      }
    },
    removeOption(index) {
      // 删除
      if (this.form.options.length > 2) {
        this.form.options.splice(index, 1);
      } else {
        // 如果只剩下两个选项，做相应的处理
        this.$message.error("最少两项，不可删除");
        // 或者你可以写其他的处理逻辑
        return;
      }
    },
    getTestDimensionListHandel(){
      let data = {
        test_id: this.id,
      };
      getTestDimensionList(data).then((res)=>{
        // console.log(res);
        this.selectList = res.data
        // console.log(this.seleceList);
      })
    },
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.form.img_url = fileUrl;
        });
      });
    },
    submitForm() {
      // 通过 $refs.form 获取 el-form 引用，并调用其 validate 方法来校验表单
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            // 获取表单内容
            const formData = { ...this.form };
            resolve(formData); // 返回表单内容
          } else {
            reject(new Error('表单校验失败'));
          }
        });
      });
    },
  },
};
</script>

<style>
.container {
  padding: 30px;
  box-sizing: border-box;
}
.topic_title,
.option {
  margin-bottom: 20px;
  font-size: 16px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.formlist .avatar {
  width: 178px !important;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.product-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 335px;
  height: 144px;
  line-height: 144px;
  text-align: center;
}
.product {
  width: 335px;
  height: 144px;
  display: block;
}
.optionlist {
  display: flex;
  align-items: center;
}
.optionlist .el-input {
  width: 100px;
}
.el-icon-delete {
  cursor: pointer;
}
.el-select .el-input {
  width: 200px !important;
}
.image_box{
  position: relative;
  width: 300px;
}
.imagedele{
  color: red;
  position: absolute;
  top: 45%;
  right: 10%;
}
</style>